<fd-form-input-message-group [triggers]="['mouseenter', 'mouseleave']">
  @if (type !== "number") {
    <input
      fd-form-control
      [type]="type"
      [formControl]="formControl"
      [id]="id"
      [readOnly]="to.readonly"
      [placeholder]="to.placeholder"
      [fdCompact]="true"
      [formlyAttributes]="field"
      [state]="showError ? 'error' : null"
    />
  } @else {
    <fd-step-input
      type="number"
      [formControl]="formControl"
      [ngStyle]="{ 'padding-top': '0.3rem' }"
      [id]="id"
      [readonly]="to.readonly"
      [placeholder]="to.placeholder"
      [fdCompact]="true"
      [formlyAttributes]="field"
      [state]="showError ? 'error' : null"
    >
    </fd-step-input>
  }
  @if (showError && formControl.errors) {
    <fd-form-message [type]="'error'">
      <formly-validation-message [field]="field"></formly-validation-message>
    </fd-form-message>
  }
</fd-form-input-message-group>
